import React, { useState } from 'react';
import ExoForm from '../../../components/exo/ExoForm';
import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../../api/api';
import ExoAlert from '../../../components/exo/ExoAlert';

export const NetworkStorageForm = ({
  startDataCollection,
  onCreate,
  onClose,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [alert, setAlert] = useState(null);

  const connectionTest = {
    label: t('Test Connection'),
    type: 'checkConnection',
  };

  const initialFields = [
    {
      label: t('Driver'),
      key: 'driver',
      type: 'customSelect',
      default: 'smb',
      noUnselect: true,
      options: [
        { label: 'SMB', value: 'smb' },
        { label: 'FTP', value: 'ftp' },
        { label: 'SFTP', value: 'sftp' },
      ],
    },
    {
      label: t('Name'),
      key: 'name',
      type: 'text',
    },
    {
      label: t('Host'),
      key: 'host',
      type: 'text',
    },
    {
      label: t('Root Directory'),
      key: 'rootDirectory',
      type: 'text',
    },
    {
      label: t('Project Directory'),
      key: 'projectRootDirectory',
      type: 'text',
    },
    {
      label: t('Username'),
      key: 'username',
      type: 'text',
    },
    {
      label: t('Password'),
      key: 'password',
      type: 'password',
    },
  ];

  const sshFields = [
    {
      label: t('SSH Private Key'),
      key: 'sshPrivateKey',
      type: 'text',
      multiline: true,
    },
    { label: t('SSH Key Password'), key: 'sshKeyPassword', type: 'text' },
  ];

  const [fields, setFields] = useState([...initialFields, connectionTest]);

  const fieldMap = {
    smb: [...initialFields, connectionTest],
    ftp: [...initialFields, connectionTest],
    sftp: [...initialFields, ...sshFields, connectionTest],
  };

  function handleCheckConnection(data) {
    DBRequest({
      config,
      path: `network-storages/test-connection`,
      method: API_POST(data),
      onResponse: () => handleCreateDisk(data),
      onError: () =>
        setAlert({
          message: t('Connection Failed'),
          cancelLabel: t('Schließen'),
        }),
    });
  }

  function handleResponse(data) {
    onCreate(data.data);
    onClose();
  }

  function handleCreateDisk(data) {
    const isUpdate = Boolean(startDataCollection && startDataCollection.id);
    DBRequest({
      config,
      path: isUpdate
        ? `network-storages/${startDataCollection.id}`
        : `network-storages`,
      method: isUpdate ? API_PATCH(data) : API_POST(data),
      onResponse: handleResponse,
    });
  }

  function handleChange(data) {
    if (data?.driver) {
      setFields(fieldMap[data.driver]);
    }
  }

  return (
    <>
      <ExoForm
        noEnter={true}
        header={t('Network Storage')}
        fields={fields}
        onSubmit={handleCheckConnection}
        onCancel={onClose}
        noDifferences
        startDataCollection={startDataCollection}
        onChange={handleChange}
      />
      <ExoAlert
        alert={alert || {}}
        open={Boolean(alert)}
        onClose={() => setAlert(null)}
      />
    </>
  );
};
